import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AddressModel, CustomerAddressList, CustomerVM } from 'src/app/models/customer/customer.model';
import { CheckoutDataVM, GetAddressModel,  Order, OrderProductModel } from 'src/app/models/Home/home-list.model';
import { GetProductAssetModel, WarrantyDetailsModel } from 'src/app/models/product/productAssets.modal';
import { CustomerAddressAddComponent } from 'src/app/modules/layoutModule/components/customer/customer-address-add/customer-address-add.component';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { CustomerService } from 'src/app/services/customer.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { UserService } from 'src/app/services/user.service';
import { WarrantyServiceService } from 'src/app/services/warranty-service.service';
import { CheckoutComponent } from '../checkout/checkout.component';
import { ProductWarrantyDescriptionComponent } from '../product-warranty-description/product-warranty-description.component';

@Component({
  selector: 'app-order-confirm',
  templateUrl: './order-confirm.component.html',
  styleUrls: ['./order-confirm.component.css']
})
export class OrderConfirmComponent implements OnInit {
  @Input('productId') ProductId: number;
  @Input('fileType') FileType: string = '1';
  @Input('fileChooseType') fileChooseType: string;
  @Input('ImageLoader') ImageLoader: any;

  selectedAddress: string;
  productDetail: OrderProductModel = new OrderProductModel();
  Loader: boolean = false;
  productId: number;
  warrantyId: number;
  id: number;
  userId: number;
  productAssets: GetProductAssetModel = new GetProductAssetModel();
  productImageResponseModel: Array<GetProductAssetModel> = new Array<GetProductAssetModel>();
  showImageinMainFrame: GetProductAssetModel = new GetProductAssetModel();
  customerListVM: CustomerAddressList = new CustomerAddressList();
  customerUserVM: Order = new Order();
  customerOrderVM: AddressModel = new AddressModel();
  isShown: boolean = false;
  customerOrderList: CheckoutDataVM = new CheckoutDataVM();
  getAddressModel: GetAddressModel = new GetAddressModel();
  orderShow: boolean = false;
  ProductAssetIds: string[] = [];
  Follow_list = [];
  warrantyServiceItem: WarrantyDetailsModel = new WarrantyDetailsModel();
  LoaderOrder: boolean = false;
  warrantyPriceId:  string;
  warrantyYearPrice1: string;
  isApplicationPriceSelected: string;
  warrantyYearPrice2: string;
  newwareentyPlan: string;
  warrentId: string;
  route: ActivatedRoute;
  addressAdd: boolean = true;
  selectedAddressInfo: CustomerVM = new CustomerVM();
  selectSingleAddress: boolean = false;
  deliveryRateId: string;
  showPlaceOrder: boolean = true;
  deliveryNotAvailable: boolean = false;
  productTotalPrice: string;
  isShippingRequired: string;
  item: CustomerAddressList = new CustomerAddressList();
  index: number;
  shippingRequired: boolean = true;

  constructor( private customerService: CustomerService,private modalService: NgbModal, config: NgbModalConfig, private router: Router, private alertify: AlertifyService, private localstorage: LocalstorageService, private homePageService: HomePageService, private userService: UserService, private activatedRoute: ActivatedRoute, private _customerService: CustomerService, private _warrantyServiceService: WarrantyServiceService) {
    this.warrentId = this.activatedRoute.snapshot.params.warrantyId;
    this.warrantyPriceId = this.activatedRoute.snapshot.params.warrantyPriceId;
    if(this.warrantyPriceId >= "1"){
      this.newwareentyPlan = this.warrantyPriceId;
     }
    this.isApplicationPriceSelected = this.activatedRoute.snapshot.params.isApplicationPriceSelected;
    localStorage.setItem('WarrentId', this.warrentId);
    localStorage.setItem('WarrantyPriceId', this.warrantyPriceId);
    localStorage.setItem('IsApplicationPriceSelected', this.isApplicationPriceSelected);
  }

  ngOnInit() {
    this.customerUserVM.UserId = +LocalstorageService.getUserId();
    this.activatedRoute.params.subscribe((param) => {
      this.productId = +param.productId;
    });  
    this.activatedRoute.params.subscribe((param) => {
      this.warrantyId = +param.warrantyId;
    });  
    this.productAssets.FileType = this.FileType;
    this.FileType == this.fileChooseType;
    this.CustomerOrder();   
    this.ProductSingleImage();
    this.WarrantyDetails();
  }

  CustomerOrder() {
    this.Loader = true;
    this.productAssets.ProductId = this.productId;
    this.homePageService.GetProductDetail(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productDetail = responseBody.responseData;  
          this.isShippingRequired = this.productDetail.isShippingRequired; 
          if (this.isShippingRequired == 'False') {
            this.addressAdd = false;
            this.orderShow = true;
            this.shippingRequired = false;
            this.SelectAddress(this.item, this.index);
          }  else {
            this.CustomerAddressList(); 
          } 
          this.Loader = false;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  ProductSingleImage() {
    this.productAssets.ImageLoader = true;
    this.productAssets.ProductId = this.productId;
    this.homePageService.GetProductMultipleImage(this.productAssets)
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.productAssets.ImageLoader = false;
          this.productImageResponseModel = responseBody.responseData;
          this.productImageResponseModel[0].type.toLocaleString();
          this.showImageinMainFrame = this.productImageResponseModel[0];
        }
      })
  }

  CustomerAddressList() {
    this.Loader = true;
    this._customerService.CustomerAddressList().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.Loader = false;
        this.customerListVM.CustomerList = responseBody.responseData;
      } (err) => {
        this.Loader = false;
      }
    });
  }

  SelectAddress(item, index) {
    if (this.isShippingRequired == 'True') {
    this.addressAdd = true;
    this.customerListVM.CustomerList.forEach(address => {
      address.IsSelected = false;
    });
    this.addressAdd = false;
    this.customerListVM.CustomerList[index].IsSelected = true;
    this.orderShow = false;
    this.selectedAddressInfo = item;
    this.selectSingleAddress = true;
  } 
    if (this.isShippingRequired == 'False') {
      this.selectedAddress == undefined;
      this.selectedAddress = '0';
    } else {
      this.selectedAddress = item.id;
    }
    this.productAssets.ProductId = this.productId;
    this.Loader = true;
    var warrentId = this.activatedRoute.snapshot.params.warrantyId;
    var warrantyPriceId = this.activatedRoute.snapshot.params.warrantyPriceId;
    var isApplicationPriceSelected = this.activatedRoute.snapshot.params.isApplicationPriceSelected;
    if(warrentId){
    this.homePageService.GetOrderWarrantyDetails(this.productAssets.ProductId, this.selectedAddress, warrentId, warrantyPriceId, isApplicationPriceSelected )
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.Loader = false;
          this.orderShow = true;  
          this.customerOrderList = responseBody.responseData;
          this.productTotalPrice = this.customerOrderList.totalPriceFormatted;
          if(this.customerOrderList.isDeliveryAvailable) {
            this.showPlaceOrder = true;
          } else if (this.isShippingRequired == 'False') {
            this.deliveryNotAvailable = false;
          } else {
            this.deliveryNotAvailable = true;
            this.showPlaceOrder = false;
          } 
          this.deliveryRateId = this.customerOrderList.rateId;
          if (this.deliveryRateId == "") {
            this.deliveryRateId = '0';
          }
          localStorage.setItem("deliveryRateId",this.deliveryRateId);
        } (err) => {
          this.Loader = false;
          this.showPlaceOrder = false;
        }
      }); 
    } else {
      this.homePageService.GetOrderDetails(this.productAssets.ProductId, this.selectedAddress )
      .subscribe((response) => {
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.Loader = false;
          this.orderShow = true;
          this.customerOrderList = responseBody.responseData;
          this.productTotalPrice = this.customerOrderList.totalPriceFormatted;
          if(this.customerOrderList.isDeliveryAvailable) {
            this.showPlaceOrder = true;
          } else if (this.isShippingRequired == 'False') {
            this.deliveryNotAvailable = false;
          } else {
            this.deliveryNotAvailable = true;
          }
          this.deliveryRateId = this.customerOrderList.rateId;
          if (this.deliveryRateId == "") {
            this.deliveryRateId = '0';
          }
          localStorage.setItem("deliveryRateId",this.deliveryRateId);
        } (err) => {
          this.Loader = false;
        }
      });
    }
  }

  PlaceOrder() {
    this.LoaderOrder = true;    
    this.productAssets.ProductId = this.productId;
    var getAddressId = this.selectedAddress;
    localStorage.setItem('productId', this.productAssets.ProductId.toString());
    localStorage.setItem('addressId', getAddressId.toString());
    var warrantyId = this.activatedRoute.snapshot.params.warrantyId;
    var warrantyPriceId = this.activatedRoute.snapshot.params.warrantyPriceId;
    var isApplicationPriceSelected = this.activatedRoute.snapshot.params.isApplicationPriceSelected;
    if(warrantyId){
    this.homePageService.WarrantyCustomerOrderPlace(this.productAssets.ProductId, getAddressId, this.deliveryRateId, warrantyId, warrantyPriceId, isApplicationPriceSelected)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.CheckOut(responseBody.responseData);
        this.LoaderOrder = false;
      });
    } else {
      this.homePageService.CustomerOrderPlace(this.productAssets.ProductId, getAddressId, this.deliveryRateId)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.CheckOut(responseBody.responseData);
        this.LoaderOrder = false;
      });
    }
  }

  CheckOut(secrectKey:string) {
    var modalConfig = new NgbModalConfig();
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(CheckoutComponent, modalConfig);
    modalRef.componentInstance.clientSecret = secrectKey;
    modalRef.componentInstance.productTotalPrice = this.productTotalPrice;
  }

  WarrantyDetails() {
    this.Loader = true;
    this.warrantyServiceItem.warrantyId = this.warrantyId
    this._warrantyServiceService.ProductWarrantyServiceList(this.warrantyServiceItem)
      .subscribe(response => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.warrantyServiceItem = responseBody.responseData;
          var durationWithPrizeList = JSON.parse(this.warrantyServiceItem.duration);
          for (var i = 0; i < durationWithPrizeList.length; i++) {
            if (durationWithPrizeList[i].Duration == this.warrantyPriceId) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.warrantyPriceId) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.warrantyPriceId) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } else if (durationWithPrizeList[i].Duration == this.warrantyPriceId) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            }
            else if (durationWithPrizeList[i].Duration == this.warrantyPriceId) {
              this.warrantyYearPrice1 = durationWithPrizeList[i].Price;
            } 
            if(this.isApplicationPriceSelected == "1") {
              this.warrantyYearPrice2 = durationWithPrizeList[i].Price;
            }
          }
        }
      });
  }

  ProductWarrantyDetails(ProductWarrantyDetails: WarrantyDetailsModel) {
    localStorage.setItem('WarrantyDescription', this.warrantyId.toString());
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this._customerService.passId(ProductWarrantyDetails.warrantyId);
    let modalRef = this.modalService.open(ProductWarrantyDescriptionComponent, modalConfig);
  }

  ChangeWarrantyPlan() {
    this.router.navigate(['/product-page/' + this.productId]);
  }

  OrderConfirm(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + this.productId]));
      window.open('#' + url, '_blank');
  }

  CancelWarrantyPlan() {
  localStorage.removeItem("WarrentId")
  this.router.navigate(['/order-confirm/' + this.productId]);  
}
 
  EditAddress(){
  this.addressAdd = true;
  this.deliveryNotAvailable = false;
  this.showPlaceOrder = true;
  this.orderShow = false;
}

  addAddress() {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(CustomerAddressAddComponent, modalConfig);
    modalRef.componentInstance.ProductId = this.productId;
    modalRef.result.then(() => {
    }, (reason) => {
      this.CustomerAddressList();
      this.Loader = false;
    })
  }

  shopNow() {
    this.router.navigate(['/home-page']);
  }
}

